export const exportHeaders = [
    {
        label: "Shipto",
        key: "shipto"
    },
    {
        label: "Account Name",
        key: "practise_name"
    },
    {
        label: "City",
        key: "city"
    },
    // {
    //     label: "Email",
    //     key: "email"
    // },
    {
        label: "Segment",
        key: "segment_code"
    },
    {
        label: "Plan",
        key: "plan"
    },
    {
        label: "Cancel Request Received Date",
        key: "cancel_request_date"
    },
    {
        label: "Cancel Request Initiated by",
        key: "cancel_request_initiated_by"
    },
    {
        label: "Cancellation Reason",
        key: "reason"
    },
    {
        label: "Cancellation Notes",
        key: "notes"
    },
    {
        label: "Billing Notified",
        key: "billing_fp_notification"
    },
    {
        label: "Billing Removed by",
        key: "billing_removed_by"
    },
    {
        label: "Billing End Date",
        key: "billing_end_date"
    },
    {
        label: "Sales Plan",
        key: "sales_plan"
    },
    {
        label: "Sales Plan Removed By",
        key: "sales_plan_removed_by"
    },
    {
        label: "Sales Plan Removed Date",
        key: "sales_plan_removed_date"
    },
    {
        label: "FF/Surcharge",
        key: "ff_surcharge"
    },
    {
        label: "FF/Surcharge Removed by",
        key: "ff_surcharge_removed_by"
    },
    {
        label: "FF/Surcharge Removed Date",
        key: "ff_surcharge_removed_date"
    },
    
    {
        label: "Signature End date",
        key: "payment_plan_end_date"
    },
    {
        label: "Payment Plan Removed by",
        key: "payment_plan_removed_by"
    },
    // {
    //     label: "HSD Service Rates Email status for Unenrollments",
    //     key: "hsd_unenrollment_status"
    // },
    {
        label: "HSD Service Rates Email status for Unenrollments",
        key: "hsd_sync_date"
    },
     {
        label: "Unenrollment Cancel Request Date",
        key: "unenrollment_cancel_request_date"
    },
     {
        label: "Unenrollment Cancel Request Initiated by",
        key: "unenrollment_cancel_request_initiated_by"
    },
     {
        label: "Unenrollment Cancel Reason",
        key: "unenrollment_cancel_reason"
    },
    {
        label: "Credit",
        key: "credit"
    },
    {
        label: "Credit Value",
        key: "credit_value"
    },
    {
        label: "Credit Applied Command",
        key: "credit_applied"
    }

]